import { Eloqua } from '@interfaces/forms';
import { Inject, Injectable } from '@angular/core';
import { Location } from '@angular/common';

import { LanguageService } from '@services/language/language.service';

import { ELOQUA_LANGUAGES } from '@core/config';

@Injectable({ providedIn: 'root' })
export class EloquaDataEnricher {
  constructor(@Inject(Location) private location: Location) {}

  public addMetadata(payload: Eloqua.Submission.Body, formConfig: Eloqua.FormConfig): Eloqua.Submission.Body {
    this.addLanguage(payload, formConfig);
    this.addUtmData(payload);
    this.addUrl(payload);

    return payload;
  }

  private addLanguage(payload: Eloqua.Submission.Body, formConfig: Eloqua.FormConfig): void {
    // TODO: clarify if this field always has merge id 59
    const hiddenLanguageControl = formConfig.controls.find(control => control.mergeId === '59');

    if (!hiddenLanguageControl) {
      return;
    }

    let language: string;

    try {
      const isoAlpha2 = navigator.language.split('-')?.[0]?.toLowerCase() ?? 'unknown';

      language =
        ELOQUA_LANGUAGES[isoAlpha2] || ELOQUA_LANGUAGES[LanguageService.selectedLanguage.toLowerCase()] || ELOQUA_LANGUAGES.en;
    } catch (e) {
      language = ELOQUA_LANGUAGES.en;
    }

    payload.fieldValues.find(fieldValue => fieldValue.id === hiddenLanguageControl.id).value = language;
  }

  private addUtmData(payload: Eloqua.Submission.Body) {
    // SPS wants utm_source to be passed as "utm_src" AND "category"

    const utmParamMap: { [fieldValueKey: string]: string } = {
      utm_source: 'utm_source',
      category: 'utm_source',
      utm_medium: 'utm_medium',
      utm_campaign: 'utm_campaign',
      utm_id: 'utm_id',
    };

    Object.entries(utmParamMap).forEach(([target, source]) => {
      const utmField = payload.fieldValues.find(fieldValue => fieldValue.name === target);

      if (!utmField) {
        return;
      }

      const urlParamValue = this.getUrlParam(source);

      if (!urlParamValue) {
        return;
      }

      utmField.value = urlParamValue;
    });
  }

  private addUrl(payload: Eloqua.Submission.Body): void {
    const field = payload.fieldValues.find(fieldValue => fieldValue.name === 'url');

    if (!field) {
      return;
    }

    field.value = typeof location === 'undefined' ? this.location.path() : location.href;
  }

  private getUrlParam(key: string): string {
    return this.getUrlParams()[key];
  }

  private getUrlParams(): Record<string, string> {
    let url = '';

    try {
      url = this.location.path() || '';

      const parts = url.split(/[?&]/).filter(part => part.includes('='));

      return parts.reduce((p, c) => {
        const [key, value] = c.split('=');
        return { ...p, [key]: value };
      }, {});
    } catch (e) {
      return {};
    }
  }
}
